<template>
    <div class="section dark_pink">
        <div class="part part-loyers">
            <el-edit-mode :theme="editModeTheme" @change="updateCharts" />

            <slot :table_livraisons="table_livraisons" :ratio_dynamisme_periode_passee="ratio_dynamisme_periode_passee" :chart_evolution_loyers="chart_evolution_loyers"
:evolution_loyer_chart_key="evolution_loyer_chart_key" :liste_kpi="liste_kpi">
                <div>
                    <div class="tle-row">
                        <div class="tle-col half" v-if="table_livraisons">
                            <p class="label main_color_text">{{ table_livraisons.title }}</p>
                            <el-table :table="table_livraisons" />
                            <dynamisme-construction-locative class="q-mt-md" :ratio_dynamisme_periode_passee="ratio_dynamisme_periode_passee"/>
                            <br />
                        </div>
                        <div class="tle-col half">
                            <chart-evolution-loyer
                            :chart_evolution_loyers="chart_evolution_loyers"
                            :evolution_loyer_chart_key="evolution_loyer_chart_key"
                            />
                            <!-- <p class="source">
                                Source : Clameur, logements neufs et anciens rénovés, loyers exprimés hors charges en surface
                                habitable. Cf. Lexique.
                            </p> -->
                        </div>
                    </div>
                    <div class="tle-row">
                        <div class="tle-col two-third">
                            <p class="label main_color_text">Quartier d'appartenance du projet</p>
                            <p class="label-info">{{types_logements[type_logement]}} : loyers pratiqués localement</p>
                            <el-table class="table_logements_neufs" :table="table_logements_neufs" :editable="true" />
                            <!-- <p class="source">Source : Expertise ADEQUATION</p> -->
                            <div class="part part-pinel q-mt-md">
                                <div class="tle-row condensed">
                                    <div class="tle-col one-third" v-for="(square, i) in liste_kpi_filtered" :key="'kpi'+i">
                                        <el-square
                                            :parent_data="square"
                                            property="value"
                                            :label="square.label"
                                            :format="square.label.toLowerCase() == 'zonage pinel' ? 'string' : 'number'"
                                            :sub_value="{'value':square.legend}"
                                            :suffix="square.unit"
                                            :editable="square.label.toLowerCase() == 'zonage pinel' || square.label.toLowerCase() == 'loyer pinel (su)'"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="box-edit lefter left" v-show="editor.mode == 'editing'">
                            <div class="box-edit-line">
                                <label>Nombre de lignes</label>
                                <input
                                    type="range"
                                    :value="logements_neufs_lines"
                                    @input="logements_neufs_lines = $event.target.value"
                                    min="3" max="5" step="1" />
                                <span class="value">{{ logements_neufs_lines }} lignes</span>
                            </div>
                        </div>
                        <div class="tle-col one-third">
                            <div class="comment">
                                <el-textarea
                                    :parent_data="active_study.etudeData.marche_locatif"
                                    property="commentaire"
                                    :editable="true"
                                    placeholder="Indiquer le niveau de tension locative (sous offre ou sur offre ?)"
                                    height='298px'
                                    overflow_edit='hidden scroll'
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </slot>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import getParameter from "@/libs/get_parameter.js";
import PageMixin from "@/components/study/editor/pages/page.mixin.js";
import DynamismeConstructionLocative from "@/components/study/editor/elements/data/dynamisme-construction-locative.vue";
import ChartEvolutionLoyer from "@/components/study/editor/elements/data/chart-evolution-loyer";

export default {
	name: "section-situation-marche-locatif",
	components: {
		DynamismeConstructionLocative,
		ChartEvolutionLoyer
	},
	mixins: [PageMixin],
	data: () => ({
		// part_investisseur_ecln: -1,
		evolution_loyer_chart_key: 0,
		types_logements: {
			logement_neuf: "Logements neufs",
			logement_recent: "Logements récents",
			logement_ancien: "Logements anciens en bon état"
		}
	}),
	props: {
		livraisonsQlikComponentId: {
			type: String,
			default: "5.1"
		},
		ratioDynamismeQlikComponentId: {
			type: String,
			default: "5.2"
		},
		evolutionLoyerQlikComponentId: {
			type: String,
			default: "5.3"
		},
		kpiQlikComponentId: {
			type: String,
			default: "5.4"
		},
		livraisonsQlikComponentName: {
			type: String,
			default: "livraisons"
		},
		ratioDynamismeQlikComponentName: {
			type: String,
			default: "dynamisme construction locative libre"
		},
		evolutionLoyerQlikComponentName: {
			type: String,
			default: "loyers1"
		},
		kpiQlikComponentName: {
			type: String,
			default: "loyers2"
		},
		editModeTheme: {
			type: String,
			required: true
		}
	},
	computed: {
		...mapGetters(["active_study", "etude_data", "editor","app_parameters"]),
		liste_kpi_filtered () {
			// remove "ZONAGE LOCATIF SOCIAL" KPI for LLI studies
			const hasSegmentCode = this.active_study.segment != undefined && this.active_study.segment.code != undefined;
			if(!hasSegmentCode || (this.active_study.segment.code !== "LLI" && this.active_study.segment.code !== "LAC")){
				return this.liste_kpi;
			}
			const data = [];
			for(const kpi of this.liste_kpi ){
				if(kpi.label.toUpperCase() !== "ZONAGE LOCATIF SOCIAL"){
					data.push(kpi);
				}
			}
			return data;
		},
		table_logements_neufs () {
			return this.get_table_logements_neufs();
		},
		logements_neufs_lines: {
			get () {
				return this.active_study.etudeData.marche_locatif["logements_neufs_lines"];
			},
			set (value) {
				this.$store.dispatch("edit_object", {
					obj: this.active_study.etudeData.marche_locatif,
					field: "logements_neufs_lines",
					value: parseInt(value)
				});
			}
		},
		self () {
			return this;
		},
		parameters () {
			return this.active_study.qlikData.parameters.editmode.find((editmode) => {
				return editmode.theme == this.editModeTheme;
			});
		},
		zone_geo_clameur () {
			let defaultValue = null;

			if(this.parameters) {
				defaultValue = this.parameters.geo.default;
			}

			return getParameter(this.etude_data, this.editModeTheme, "zoneGeo", defaultValue);
		},
		type_logement () {
			return getParameter(this.etude_data, this.editModeTheme, "typeLogement", "logement_neuf");
		},
		table_livraisons: function () {
			if(!this.livraisonsQlikComponentId) {
				return false;
			}

			// TODO - make sure it is always at the 'commune' level
			const table = {
				head: [],
				body: [],
				config: {
					cols_width: [28, 18, 18, 18, 18],
				},
			};
			try{
				let component = this.active_study.qlikData.component.find((comp) => {
					return comp.name == this.livraisonsQlikComponentName || comp.id == this.livraisonsQlikComponentId;
				});

				table.title = component.title.find((title) => {
					return title.code == this.zone_geo_clameur;
				}).value;

				if(this.active_study.projet.adresse.ville) {
					const currentCity = this.active_study.projet.adresse.ville.toLowerCase();
    
					if(["lyon", "marseille", "paris"].includes(currentCity)) {
						table.title = table.title.replace("la commune", "l'arrondissement");
					}
				}

				//todelete : switch mode error/nominal (false => error case)
				// component.valid = true;
				//throw "il y a une erreur"

				// if an error is detectd in back => set componenet from default_component
				if (component.valid == false){
					//get error_message from component
					// table.error_message="[BACK] : "+component.errorMessage;
					table.error_message = "Donnée non disponible";
					//get defualt component
					component = this.app_parameters.default_components.find((component) => {
						return component.name == "livraisons" || component.id == "5.1";
					});
					table.error = true;
				}

				const header = component.content[this.zone_geo_clameur].header_list.reduce((accu, curr) => {
					accu.push(curr.value);
					return accu;
				}, []);
				table.head.push(header);
				// table.head.push(["", "Libre", "Interm.", "PLS", "Total"]);


				const body = component.content[this.zone_geo_clameur].data_list.reduce((accu, curr) => {
					const temp = curr.values.reduce((accu2, curr2) => {
						accu2.push(curr2.value);
						return accu2;
					}, []);
					accu.push([curr.label, ...temp]);
					return accu;
				}, []);
				table.body = body;
			}catch(error){
				console.warn(error);
				//get default component
				const component = this.app_parameters.default_components.find((component) => {
					return component.name == "livraisons" || component.id == "5.1";
				});
				
				table.error = true;
				// table.error_message= "[FRONT] : Une erreur est survenue veuillez contacter un administrateur!  : "+error;
				table.error_message = "Donnée non disponible";

				const header = component.content.commune.header_list.reduce((accu, curr) => {
					accu.push(curr.value);
					return accu;
				}, []);
				table.head.push(header);
                
				const body = component.content.commune.data_list.reduce((accu, curr) => {
					const temp = curr.values.reduce((accu2, curr2) => {
						accu2.push(curr2.value);
						return accu2;
					}, []);
					accu.push([curr.label, ...temp]);
					return accu;
				}, []);
				table.body = body;
			}
			return table;
		},
		ratio_dynamisme_periode_passee () {

			let ratio1 = {};
			let component = {};
			try{
				component = this.active_study.qlikData.component.find((component) => {
					return component.name == this.ratioDynamismeQlikComponentName || component.id == this.ratioDynamismeQlikComponentId;
				});

				//todelete : switch mode error/nominal (false => error case)
				//component.valid = true;
				//throw "il y a une erreur"

				if(component.valid == false){
					//set null component
					component = {};

					ratio1 = {};
					ratio1.labels = [];
					ratio1.value = "0";
					ratio1.values = [];
					ratio1.max = "8";
					ratio1.legend = "";

					//get error_message from component
					// ratio1.error_message="[BACK] : "+component.errorMessage;
					ratio1.error_message = "Donnée non disponible";
					ratio1.error = true;
				}else{
					ratio1 = {value: Math.min(component.content.epci.data_list[0].value_object.value.replace(",", "."), component.content.epci.header.max)};
					ratio1.values = component.content.epci.header.values;
					ratio1.max = component.content.epci.header.max;
					ratio1.labels = component.content.epci.header.labels;
					ratio1.legend = component.content.epci.data_list[0].label;
				}

               
			}catch(error){
				ratio1 = {};
				ratio1.labels = [];
				ratio1.value = "0";
				ratio1.values = [];
				ratio1.max = "8";
				ratio1.legend = "";
                
				ratio1.error = true;
				// ratio1.error_message="[FRONT] : Une erreur est survenue veuillez contacter un administrateur!  : "+error;
				ratio1.error_message = "Donnée non disponible";
			}
           

			return ratio1;
		},
		chart_evolution_loyers: function () {
			const temp = { labels: [], datasets: [] };
			try{
				//let chart_lines = [];
				const component = this.active_study.qlikData.component.find((component) => {
					return component.id == this.evolutionLoyerQlikComponentId || component.name == this.evolutionLoyerQlikComponentName;
				});

				temp.title = component.title.find((title) => {
					return title.code == this.zone_geo_clameur;
				});

				//todelete : switch mode error/nominal (false => error case)
				//component.valid = true;
				//throw "il y a une erreur"
				if( component.valid == false){
					temp.error = true;
					// temp.error_message = "[BACK] : "+component.errorMessage;
					temp.error_message = "Donnée non disponible";
				}else{

					const keys = {
						t1: { label: "T1", borderColor: "#03A9F4", pointBorderColor: "#03A9F4", backgroundColor: "#03A9F4", fill: false, pointStyle: "dot", pointRadius: 4, pointBackgroundColor: "#fff", pointBorderWidth: 2, yAxisID: undefined },
						t2: { label: "T2", borderColor: "#FF9800", pointBorderColor: "#FF9800", backgroundColor: "#FF9800", fill: false, pointStyle: "dot", pointRadius: 4, pointBackgroundColor: "#fff", pointBorderWidth: 2, yAxisID: undefined },
						t3: { label: "T3", borderColor: "#f44336", pointBorderColor: "#f44336", backgroundColor: "#f44336", fill: false, pointStyle: "dot", pointRadius: 4, pointBackgroundColor: "#fff", pointBorderWidth: 2, yAxisID: undefined },
						t4: { label: "T4", borderColor: "#8BC34A", pointBorderColor: "#8BC34A", backgroundColor: "#8BC34A", fill: false, pointStyle: "dot", pointRadius: 4, pointBackgroundColor: "#fff", pointBorderWidth: 2, yAxisID: undefined },
					};

					const datasets = [];

					Object.entries(keys).forEach((key) => {
						const temp = [];
						component.content[this.zone_geo_clameur].data_list.forEach((elem) => {
							temp.push(elem[key[0]].value);
						});

						keys[key[0]].data = temp;
						datasets.push(keys[key[0]]);
					});
                
					temp.datasets = datasets;
                    
					const labels = component.content[this.zone_geo_clameur].header_list.reduce((accu, curr) => {
						accu.push(curr.value);
						return accu;
					}, []);

					temp.labels = labels;
				}
            

			} catch(error){
				temp.error = true;
				// temp.error_message = "[FRONT] : Une erreur est survenue veuillez contacter un administrateur!  : "+error;
				temp.error_message = "Donnée non disponible";
			}

			return temp;
		},
		kpiQlikComponent () {
			return this.active_study.qlikData.component.find((component) => {
				return component.name == this.kpiQlikComponentName || component.id == this.kpiQlikComponentId;
			});
		},
		liste_kpi () {
			if (this.kpiQlikComponent.content[this.zone_geo_clameur])
				return this.kpiQlikComponent.content[this.zone_geo_clameur].data_list;
			else
				return this.kpiQlikComponent.content["epci"].data_list;
		}
	},
	methods: {
		get_table_logements_neufs: function () {
			if(isNaN(this.active_study.etudeData.marche_locatif["logements_neufs_lines"])){ // A revoir
				this.logements_neufs_lines = 5;
			}
			const table = {
				head: [],
				body: [],
				config: {
					cols_width: [8, 13, 1, 13, 14, 17, 16, 18], // sum == 100%
				},
			};

			table.head.push([
				"",
				{ value: "Surface habit.", colspan: 3 },
				{ value: "Loyer (HC)", colspan: 2 },
				{ value: "Loyer €/m²", colspan: 2 },
			]);
			//let base_path = "";
			const loyers_neufs = Object.keys(this.active_study.etudeData.marche_locatif.loyers_neufs);
			loyers_neufs.forEach( (type, i) => {
				if (i >= this.logements_neufs_lines) {
					return ;
				}
				const ref = this.active_study.etudeData.marche_locatif.loyers_neufs[type];
				table.body.push([
					{
						parent_data: ref,
						property: "type",
						editable: true,
						border: "border_right",
					},
					{
						parent_data: ref,
						property: "surface_habitable_min",
						editable: true,
						// prefix: "de",
						// border: "border_right",
						text_align: "center",
					},
					{
						value: "-",
						text_align: "center"
					},
					{
						parent_data: ref,
						property: "surface_habitable_max",
						suffix: "m²",
						editable: true,
						border: "border_right",
						text_align: "center",
					},
					{
						parent_data: ref,
						property: "loyer_hc_hs_min",
						editable: true,
						// prefix: "de",
						suffix: "-",
						text_align: "center",
					},
					{
						parent_data: ref,
						property: "loyer_hc_hs_max",
						// prefix: "à",
						suffix: "€",
						editable: true,
						border: "border_right",
						text_align: "center",
					},
					{
						parent_data: ref,
						property: "loyer_m2_min",
						editable: true,
						// prefix: "de",
						suffix: "-",
						format: "number",
						text_align: "center",
					},
					{
						parent_data: ref,
						property: "loyer_m2_max",
						// prefix: "à",
						suffix: "€/m²",
						editable: true,
						format: "number",
						text_align: "center",
					},
				]);
			});
			return table;
		},
		updateCharts () {
			this.evolution_loyer_chart_key += 1;
		}
	}
};
</script>

<style lang="stylus" scoped>
@import '../../../../../assets/css/app'
@import '../../../../../assets/css/page'

input[type='radio']
  vertical-align baseline
  padding 4px
  margin 4px
  color lighten(purple, 85%)

input[type='radio'] + label
  margin-left 4px

label
  display inline-block
  text-transform uppercase
  font-size 10px
  font-weight 500

input[type='range']
  display inline-block
  width 75%

.value
  float right
  width 25%
  padding 0 0 0 8px
  font-weight 500
  text-align center
  white-space nowrap
</style>
